<template>
    <div
        v-for="option in message.config?.option" :key="option"
        class="dk--bot-select-option"
        :class="{
          'dk--option-selected': message.answered && option.value === message.answer,
          'dk--option-hidden': message.answered && option.value !== message.answer
        }"
        @click.once="sendAnswer(option.value)"
    >
      {{ option.label }}
    </div>
</template>

<script>
import { store } from "@/store";

export default {
  name: "DkBotSelect",
  props: {
    message: Object
  },
  data() {
    return {
      store,
    }
  },
  methods: {
    sendAnswer(value) {
      this.store.sendAnswer(this.message.ID, value);
    }
  }
}
</script>

<style lang="scss">
.dk--bot-select-option {
  border: 1px solid var(--dk--bot-answer-border-color);
  color: var(--dk--bot-answer-color) !important;
  padding: 0px 11px;
  border-radius: var(--dk--bot-answer-border-radius);
  cursor: pointer;
  background-color: var(--dk--bot-answer-bg-color);
  min-width: var(--dk--bot-answer-min-width);
  min-height: var(--dk--bot-answer-height);
  line-height: var(--dk--bot-answer-height);
  box-sizing: border-box;
  text-align: center;

  &.dk--option-selected {
    color: var(--dk--bot-answered-color) !important;
    background-color: var(--dk--bot-answered-bg-color);
    cursor: default;
    transition: var(--dk--bot-answered-transition);
  }

  &.dk--option-hidden {
    display: none;
  }
}
</style>